<template>
  <section class="ViewMainAbout">
    <div class="ViewMainAbout__row">
      <div class="ViewMainAbout__col ViewMainAbout__col--content">
        <h2 class="ViewMainAbout__title">
          OPEN OIL MARKET – это комплексная цифровая платформа, объединяющая
          поставщиков, покупателей, перевозчиков, финансовых партнеров.
        </h2>
        <div class="ViewMainAbout__text">
          <p>
            Больше прозрачности, уменьшение рисков при принятии решений о
            закупке или продаже продукции, что помогает действовать более
            эффективно в условиях быстро меняющегося делового окружения.
          </p>
          <p>
            На маркетплейсе можно купить нефтепродукты в объеме от 5000 до 40
            000 литров с доставкой и на самовывоз. Все заявки оформляются в
            личном кабинете или в мобильном приложении. Там же можно получить
            информацию по статусу заказа, первичные и закрывающие документы.
            Клиенты маркетплейса могут воспользоваться кредитными предложениями
            от ведущих банков и купить топливо в кредит. Денежные средства
            предоставляют крупнейшие банки России.
          </p>
        </div>
        <router-link
          v-if="showBtnMore"
          to="/offers/page/1"
          class="ViewMainAbout__btn app-button-control app-button-control--secondary"
        >
          <span class="app-button-control__content">
            <span>Показать все предложения</span>
            <app-svg-icon
              name="arrow-circle"
              isCurrentColor
              class="ViewMainAbout__btn-icon"
            ></app-svg-icon
          ></span>
        </router-link>
      </div>
      <div class="ViewMainAbout__col">
        <a
          href="https://rutube.ru/video/318a764a6310d50f089f0b4b62e2bdd5/?r=wd"
          target="_blank"
          class="ViewMainAbout__media"
        >
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ViewMainAbout',
  components: {
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  props: {
    showBtnMore: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.ViewMainAbout {
  &__text {
    max-width: rem(600);
    font-size: 15px;
    font-weight: 300;
    line-height: 1.5;

    p {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  &__row {
    display: flex;
    gap: 30px;

    @include media-sm() {
      flex-wrap: wrap;
    }
  }

  &__media-btn {
    display: inline-flex;
    align-items: center;
    height: rem(65);
    padding: 0 rem(30);
    font-size: rem(16);
    font-weight: 700;
    line-height: 1.3;
    color: #000;
    text-decoration: none;
    text-transform: uppercase;
    background: #fff;
    border: solid 2px #02b55f;
    border-color: solid 1px rgb(114, 175, 50);
    border-radius: 4px;
    transition: color $A;

    @include media-lg('up') {
      letter-spacing: 0.04em;
    }

    @include media-lg() {
      height: rem(55);
      font-size: rem(14);
    }

    &:hover {
      color: #02b55f;
    }
  }

  &__media-btn-icon {
    flex-shrink: 0;
    width: rem(32);
    height: rem(32);
    margin-left: rem(12);
    fill: #02b55f;
  }

  &__media {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    max-width: 100%;
    height: 100%;
    padding: 30px;
    background: url('/static/images/main-video.png') top center no-repeat;
    background-size: contain;

    @include aspect-ratio(800, 450);
  }

  &__col {
    width: 50%;

    @include media-sm() {
      width: 100%;
    }

    &--content {
      position: relative;
      padding-right: rem(80);
      padding-left: rem(55);

      @include media-lg {
        padding-right: rem(15);
        padding-left: rem(30);
      }

      @include media-md {
        margin-bottom: rem(30);
      }

      @include media-sm {
        padding-right: 0;
      }
    }
  }

  &__title {
    position: relative;
    max-width: rem(600);
    margin-top: 0;
    font-size: rem(24);
    font-weight: 700;
    line-height: 1.2;
    color: #352a52;

    &::before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: rem(-55);
      width: rem(4);
      content: '';
      background: #02b55f;

      @include media-lg {
        left: rem(-30);
      }
    }

    @include media-lg {
      margin-top: 0;
      font-size: rem(22);
    }

    @include media-sm {
      font-size: rem(18);
    }
  }

  &__btn {
    padding: 0 rem(20);
    margin-top: rem(30);
    line-height: 1.2;
  }

  &__btn-icon {
    width: rem(16);
    height: rem(16);
    margin-left: rem(15);
  }
}
</style>
